// extracted by mini-css-extract-plugin
export default {"before":"Before_before__NCjf-","after":"Before_after__WkNd3","beforeDis":"Before_beforeDis__EnhFY","arrow":"Before_arrow__WF1Nq","beforeSection":"Before_beforeSection__RkHWU"};